export const IssueFabricList = {
  tabs: [
    {
      label: 'All Issued Fabric List',
      id: 1,
    },
  ],
};
